/**
 * @desc 作废拣货单
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(pickNo: string | number, options?: any) {
  return updateResponse(
    http(URL + `/pickMaster/cancelPick/${pickNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
